<template>
  <div
    class="linkbox-wrapper"
  >
    <div
      v-if="hasBeforeSlot"
      class="linkbox-before"
    >
      <slot name="before" />
    </div>
    <div
      v-if="hasAfterSlot"
      class="linkbox-after"
    >
      <slot name="after" />
    </div>
    <PbLink
      v-bind="$attrs"
      class="linkbox-link"
    >
      <slot name="default" />
    </PbLink>
  </div>
</template>

<script setup>
import useHasContent from '@nicolaudie-group/ng-ui-kit/composables/useHasContent'
import PbLink from '@/components/PbLink.vue'

defineOptions({
  compatConfig: {
    MODE: 3, // opt-in to Vue 3 behavior for this component only
  },
  inheritAttrs: false,
  customOptions: {},
})

const hasBeforeSlot = useHasContent('before')
const hasAfterSlot = useHasContent('after')
</script>

<style lang="scss" src="./LinkBox.scss" />
